import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestScannerResultIgnorePost = {
    path: "/scanner/result/ignore",
    method: RouteHttpVerb.POST
};
